module.exports = __webpack_public_path__ + "static/assets/872031593c5ab3d019cd4df008f49816.png";